export default __webpack_public_path__ + "static/media/CompstColab.df52c3ce.png";